/**
 * Označuje místa v kódu, kde implementace není dokončena.
 */
export class NotImplementedError extends Error {
  constructor(message?: string) {
    super(message ?? "Not implemented.");
    Object.setPrototypeOf(this, NotImplementedError.prototype);
  }
}
